module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/contact_collector-9c81aff4624f08ae4f213884682b55c7.webp";